import { Box, Container, Typography } from "@mui/material";
import Grid2 from "@mui/material/Grid2";
import { ArrowForward } from "@mui/icons-material";

const TypicalRoles = () => {
  return (
    <Box
      component="section"
      id="problem"
      sx={{
        width: "100%",
        py: { xs: 10, md: 14 },
        background: "linear-gradient(135deg, #1e293b 0%, #0f172a 100%)",
        position: "relative",
        overflow: "hidden",
      }}
    >
      <Box
        sx={{
          position: "absolute",
          top: "30%",
          right: "90%",
          width: 600,
          height: 600,
          background:
            "radial-gradient(circle at center, rgba(77, 222, 128, 0.35), transparent 70%)",
          borderRadius: "50%",
          zIndex: 0,
        }}
      />

      <Container maxWidth="lg" sx={{ position: "relative" }}>
        <Box sx={{ textAlign: "center", mb: { xs: 6, md: 9 } }}>
          <Typography
            variant="h3"
            sx={{
              color: "white",
              fontWeight: 900,
              letterSpacing: -0.7,
              mb: 2,
            }}
          >
            PATHWAYS is built for Evangelism Leads
          </Typography>

          <Typography
            variant="h6"
            sx={{
              color: "rgba(255,255,255,0.82)",
              maxWidth: 760,
              mx: "auto",
              lineHeight: 1.6,
            }}
          >
            Ministry Leaders have a particular role in ensuring that their church is effectively reaching the lost and making disciples.
          </Typography>
        </Box>

        <Grid2 container spacing={{ xs: 3, md: 4 }} alignItems="stretch">
          <Grid2 size={{ xs: 12, md: 6 }}>
            <Box
              sx={{
                height: "100%",
                borderRadius: 5,
                p: { xs: 3, md: 4 },
                background: "rgba(255,255,255,0.06)",
                border: "1px solid rgba(255,255,255,0.14)",
                backdropFilter: "blur(10px)",
                boxShadow: "0 20px 60px rgba(0,0,0,0.35)",
                position: "relative",
                overflow: "hidden",
              }}
            >
              <Box
                sx={{
                  position: "absolute",
                  right: -80,
                  top: -80,
                  width: 220,
                  height: 220,
                  borderRadius: "50%",
                  background: "rgba(77, 222, 128, 0.35)",
                  filter: "blur(2px)",
                }}
              />

              <Typography
                variant="overline"
                sx={{
                  color: "rgba(255,255,255,0.72)",
                  letterSpacing: 1.8,
                  fontWeight: 800,
                }}
              >
                The typical role of
              </Typography>

              <Typography
                variant="h5"
                sx={{ color: "white", fontWeight: 900, mt: 1, mb: 3 }}
              >
                Church Members
              </Typography>

              <Box sx={{ display: "grid", gap: 1.5, mb: 3 }}>
                {[
                  "Sharing the Gospel with friends, colleagues and neighbours",
                  "Serving in evangelistic ministries and events",
                  "Building genuine relationships with individual people",
                  "Having meaningful conversations and offering personal follow-up",
                ].map((text) => (
                  <Box
                    key={text}
                    sx={{
                      display: "flex",
                      alignItems: "flex-start",
                      gap: 1.5,
                      p: 1.75,
                      borderRadius: 4,
                      background: "rgba(255,255,255,0.04)",
                      border: "1px solid rgba(255,255,255,0.10)",
                      transition: "all 0.2s ease",
                      "&:hover": {
                        background: "rgba(255,255,255,0.06)",
                        borderColor: "rgba(255,255,255,0.16)",
                      },
                    }}
                  >
                    <ArrowForward
                      sx={{
                        mt: "3px",
                        fontSize: 18,
                        color: "rgba(255,255,255,0.70)",
                      }}
                    />
                    <Typography sx={{ color: "rgba(255,255,255,0.86)" }}>
                      {text}
                    </Typography>
                  </Box>
                ))}
              </Box>

              <Typography
                sx={{ typography: "h6", color: "rgba(255,255,255,0.82)" }}
              >
                Each member of the church sees a small but important part of the church&apos;s
                evangelism.
              </Typography>
            </Box>
          </Grid2>

          <Grid2 size={{ xs: 12, md: 6 }}>
            <Box
              sx={{
                height: "100%",
                borderRadius: 5,
                p: { xs: 3, md: 4 },
                background: "rgba(255,255,255,0.06)",
                border: "1px solid rgba(255,255,255,0.14)",
                backdropFilter: "blur(10px)",
                boxShadow: "0 20px 60px rgba(0,0,0,0.35)",
                position: "relative",
                overflow: "hidden",
              }}
            >
              <Box
                sx={{
                  position: "absolute",
                  right: -90,
                  bottom: -90,
                  width: 240,
                  height: 240,
                  borderRadius: "50%",
                  background: "rgba(77, 222, 128, 0.35)",
                  filter: "blur(2px)",
                }}
              />

              <Typography
                variant="overline"
                sx={{
                  color: "rgba(255,255,255,0.72)",
                  letterSpacing: 1.8,
                  fontWeight: 800,
                }}
              >
                The typical role of
              </Typography>

              <Typography
                variant="h5"
                sx={{ color: "white", fontWeight: 900, mt: 1, mb: 3 }}
              >
                Evangelism Leads
              </Typography>

              <Box sx={{ display: "grid", gap: 1.5, mb: 3 }}>
                {[
                  "Seeing what is happening across the church's evangelism",
                  "Coordinating multiple ministries, staff and volunteer teams",
                  "Making strategic decisions about priorities and resources",
                  "Making sure meaningful relationships receive appropriate follow-up",
                  "Learning from the ministry and helping the church improve over time",
                ].map((text) => (
                  <Box
                    key={text}
                    sx={{
                      display: "flex",
                      alignItems: "flex-start",
                      gap: 1.5,
                      p: 1.75,
                      borderRadius: 4,
                      background: "rgba(255,255,255,0.04)",
                      border: "1px solid rgba(255,255,255,0.10)",
                      transition: "all 0.2s ease",
                      "&:hover": {
                        background: "rgba(255,255,255,0.06)",
                        borderColor: "rgba(255,255,255,0.16)",
                      },
                    }}
                  >
                    <ArrowForward
                      sx={{
                        mt: "3px",
                        fontSize: 18,
                        color: "rgba(255,255,255,0.70)",
                      }}
                    />
                    <Typography sx={{ color: "rgba(255,255,255,0.86)" }}>
                      {text}
                    </Typography>
                  </Box>
                ))}
              </Box>

              <Typography
                sx={{ typography: "h6", color: "rgba(255,255,255,0.82)" }}
              >
                Evangelism leads need a way to turn hundreds of individual
                activities and relationships into one coherent strategy for their church.
              </Typography>
            </Box>
          </Grid2>
        </Grid2>
      </Container>

      <Box sx={{ textAlign: "center", mb: { xs: 6, md: 9 } }}>
        <Typography
          variant="h6"
          sx={{
            color: "white",
            fontWeight: 900,
            letterSpacing: -0.7,
            my: 10,
          }}
        >
          PATHWAYS gives evangelism leads the visibility and structure their
          role requires.
        </Typography>
      </Box>
    </Box>
  );
};

export default TypicalRoles;